export const XFactionChangeTriangleSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 55) * 28}
      viewBox="0 0 55 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M53 27L27 2L2 27H53.5Z"
        fill="url(#paint0_linear_295_6)"
        stroke="#4F4F4F"
      />
      <defs>
        <linearGradient
          id="paint0_linear_295_6"
          x1="54"
          y1="27"
          x2="2"
          y2="27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D9D9" />
          <stop offset="0.0001" stopColor="#A48849" />
          <stop offset="0.354167" stopColor="#D7C75B" />
          <stop offset="0.5" stopColor="#E3D55F" />
          <stop offset="0.640625" stopColor="#D7C75B" />
          <stop offset="1" stopColor="#A48849" />
        </linearGradient>
      </defs>
    </svg>
  );
};
